/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faInfoCircle from '@fortawesome/fontawesome-free-solid/faInfoCircle';
import faReceipt from '@fortawesome/fontawesome-free-solid/faReceipt';
import faFileImage from '@fortawesome/fontawesome-free-solid/faFileImage';
import faDollarSign from '@fortawesome/fontawesome-free-solid/faDollarSign';
import faBalanceScale from '@fortawesome/fontawesome-free-solid/faBalanceScale';

import Item from '../../../models/Item';
import {
  Header as ItemHeader,
  Overview,
  Details,
  Attachments,
  Financials,
  Services,
} from './items';
import formPropsType from '../../common/types/formPropsType';

class ItemTabs extends Component {
  render() {
    const {
      item, formProps, startInEditMode, saveButton, onDelete,
    } = this.props;

    return (
      <div>
        <ItemHeader
          item={item}
          formProps={formProps}
          onDelete={onDelete}
          saveButton={saveButton}
          startInEditMode={startInEditMode}
        />

        <Tabs>
          <TabList>
            <Tab>
              <span className="icon">
                <FontAwesomeIcon icon={faInfoCircle} fixedWidth />
              </span>{' '}
              Overview
            </Tab>
            <Tab>
              <span className="icon">
                <FontAwesomeIcon icon={faReceipt} fixedWidth />
              </span>{' '}
              Details
            </Tab>
            <Tab>
              <span className="icon">
                <FontAwesomeIcon icon={faBalanceScale} fixedWidth />
              </span>{' '}
              Services
            </Tab>
            <Tab>
              <span className="icon">
                <FontAwesomeIcon icon={faFileImage} fixedWidth />
              </span>{' '}
              Attachments
            </Tab>
            {/* A little funky, we're aliasing startInEditMode to be an indicator that this is a
                a new item page, and therefore we shouldn't be showing the financials tab. */}
            {!startInEditMode && (
              <Tab>
                <span className="icon">
                  <FontAwesomeIcon icon={faDollarSign} fixedWidth />
                </span>{' '}
                Financials
              </Tab>
            )}
          </TabList>

          <TabPanel>
            <Overview item={item} formProps={formProps} startInEditMode={startInEditMode} />
          </TabPanel>
          <TabPanel>
            <Details item={item} formProps={formProps} startInEditMode={startInEditMode} />
          </TabPanel>
          <TabPanel>
            <Services item={item} formProps={formProps} startInEditMode={startInEditMode} />
          </TabPanel>
          <TabPanel>
            <Attachments item={item} formProps={formProps} startInEditMode={startInEditMode} />
          </TabPanel>
          {!startInEditMode && (
            <TabPanel>
              <Financials item={item} formProps={formProps} startInEditMode={startInEditMode} />
            </TabPanel>
          )}
        </Tabs>
      </div>
    );
  }
}

ItemTabs.propTypes = {
  item: PropTypes.instanceOf(Item),
  formProps: formPropsType.isRequired,
  startInEditMode: PropTypes.bool,
  saveButton: PropTypes.node,
  onDelete: PropTypes.func,
};

ItemTabs.defaultProps = {
  item: null,
  startInEditMode: false,
  saveButton: null,
  onDelete: null,
};

export default ItemTabs;



// WEBPACK FOOTER //
// ./src/components/pages/collections/ItemTabs.jsx